// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"01b3a5b7","667":"837c6aec"}[chunkId] + ".chunk.js";
};